import { CSSObject, Theme } from "@mui/material";

export const FOCUS_OUTLINE_FALLBACK_COLOR = "#003C9B";

export const getFocusOutlineColor = (theme: Theme): string => {
    const variables = (theme as unknown as {
        variables?: { primaryButtonFocusBorderColor?: string };
    }).variables;

    return variables?.primaryButtonFocusBorderColor ?? FOCUS_OUTLINE_FALLBACK_COLOR;
};

export type FocusOutlineOptions = {
    offset?: number;
    borderRadius?: number | string;
    includeActive?: boolean;
};

const buildOutline = (theme: Theme, { offset = 0, borderRadius }: FocusOutlineOptions): CSSObject => ({
    outline: `3px solid ${getFocusOutlineColor(theme)}`,
    outlineOffset: offset,
    ...(borderRadius !== undefined ? { borderRadius } : {}),
});

export const getFocusOutlineSx = (theme: Theme, options: FocusOutlineOptions = {}): CSSObject => {
    const { includeActive = true } = options;
    const selectors = [
        "&.Mui-focusVisible",
        "&:focus-visible",
        ...(includeActive ? ["&:active"] : []),
    ].join(", ");

    return {
        [selectors]: buildOutline(theme, options),
    };
};
